module.exports = __webpack_public_path__ + "img/Dash_historico.e764861d.svg";